import { get, post, put, remove } from "../helpers/apiHelper";
import { Api } from "../constants";
import {
  Item,
  ItemCreateRequest,
  ItemCreateResponse,
  ItemDeleteResponse,
  ItemsFetchResponse,
  ItemUpdateRequest,
  ItemUpdateResponse,
  ItemsNewFetchRequest,
} from "../types";
import { buildItemFormData } from "../utils/apiUtils";

const API_ENDPOINTS = {
  ITEM_LISTING_STATUS: `update-item-status`,
  ITEMS_NEARBY: `items-nearby`,
  ITEMS_BY_USER_ID: `get-by-user-id`,
  NEW_ITEMS: `new-items`,
  CREATE_ITEM: `create`,
};

// Get Item detail by itemId
export const getItemDetails = async (
  itemId: string,
  options: {
    shareableLink?: boolean;
    lat?: number | null;
    lon?: number | null;
  } = {}
): Promise<Item> => {
  const { shareableLink = false, lat, lon } = options;
  let url = `${Api.items}/${itemId}`;
  if (shareableLink) {
    url = `${Api.items}/share/${itemId}`;
  }
  if (lat != null && lon != null) {
    url += `?lat=${lat}&lon=${lon}`;
  }
  return await get(url);
};

// Get nearby items by lat/long
export const getItemsNearby = async (
  lat: number,
  lon: number,
  userId?: string | null
): Promise<ItemsFetchResponse> => {
  const userIdQuery = userId ? `&userId=${userId}` : "";
  const url = `${Api.dashboard}/${API_ENDPOINTS.ITEMS_NEARBY}?lat=${lat}&lon=${lon}${userIdQuery}`;
  return await get(url);
};

// Fetch items New Listing
export const getItemsNewListing = async (
  payload: ItemsNewFetchRequest,
  userId?: string | null
): Promise<ItemsFetchResponse> => {
  const url = `${Api.dashboard}/${API_ENDPOINTS.NEW_ITEMS}`;
  const requestPayload = userId && !payload.userId ? { ...payload, userId } : payload;
  return await post(url, requestPayload);
};

//Fetch Items by User ID
export const getItemsByUserId = async (
  userId: string,
  viewerId?: string | null,
  lat?: number | null,
  lon?: number | null
): Promise<ItemsFetchResponse> => {
  const viewerIdQuery = viewerId ? `&viewerId=${viewerId}` : "";
  const locationQuery =
    lat != null && lon != null ? `&lat=${lat}&lon=${lon}` : "";
  const url = `${Api.items}/${API_ENDPOINTS.ITEMS_BY_USER_ID}?userId=${userId}${viewerIdQuery}${locationQuery}`;
  return await get(url);
};

//Create Item
export const createItem = async (
  item: ItemCreateRequest,
  images?: File[]
): Promise<ItemCreateResponse> => {
  const url = `${Api.items}/${API_ENDPOINTS.CREATE_ITEM}`;
  const formData = buildItemFormData(item, {
    images,
    includeUserId: true,
  });
  return await post(url, formData);
};

// Delete Item
export const deleteItem = async (
  itemId: string
): Promise<ItemDeleteResponse> => {
  const url = `${Api.items}/${itemId}`;
  const response = await remove(url);
  return response;
};

// Update Item
export const updateItem = async ({
  itemId,
  data,
  images,
}: ItemUpdateRequest): Promise<ItemUpdateResponse> => {
  const url = `${Api.items}/${itemId}`;
  const formData = buildItemFormData(data, {
    images,
    includeImageIds: true,
  });
  return await put(url, formData);
};

// Update Item Listing Status
export const updateItemListingStatus = async (
  itemId: string,
  status: string
): Promise<ItemUpdateResponse> => {
  const url = `${Api.items}/${API_ENDPOINTS.ITEM_LISTING_STATUS}`;
  const payloadData = {
    itemId,
    status,
  };
  return await post(url, payloadData);
};
